import TextInput from "components/Properties/InputComponents/TextInput";
import styles from "./index.module.scss";
import {ObjectIcon} from "components/AssetLayer/DraggableTree/TreeNode/icons";

const TitleComponent = ({isObjectScripting, selectedObject, textOnChange}) => {
  const canScript = selectedObject.userData.canScript || false;

  return (
    <div className={styles.container}>
      <div className={styles.child}>
        <ObjectIcon type={selectedObject.type} name={selectedObject.name} userData={selectedObject.userData} />
        {isObjectScripting || canScript ? (
          <TextInput name="Title" value={selectedObject.title} textOnChange={textOnChange} placeholder="Enter Title" />
        ) : (
          selectedObject.title
        )}
      </div>
    </div>
  );
};

export default TitleComponent;
